import React from 'react';
export function BonusSection() {
  const bonuses = [{
    id: '01',
    title: 'Trailers Desde Cero: Planos y Detalles',
    desc: 'Incluye planos profesionales para fabricar trailers completos desde cero, con medidas exactas, materiales y detalles listos para construir',
    color: 'border-l-orange-500',
    badge: 'bg-orange-500',
    value: '$29.99'
  }, {
    id: '02',
    title: 'Herrero Desde Cero',
    desc: 'Descubrí las técnicas y planos esenciales de herrería práctica, y aprendé a crear piezas funcionales con estilo profesional.',
    color: 'border-l-blue-500',
    badge: 'bg-blue-500',
    value: '$24.99'
  }, {
    id: '03',
    title: 'Máquinas de Gym Desde Cero',
    desc: 'Accedé a planos y detalles técnicos para fabricar bancos, estructuras y equipos de entrenamiento con materiales económicos y resistentes.',
    color: 'border-l-green-500',
    badge: 'bg-green-500',
    value: '$19.99'
  }, {
    id: '04',
    title: 'Soldador Desde Cero',
    desc: 'Aprendé las bases de la soldadura profesional paso a paso, con técnicas simples y seguras para crear estructuras sólidas y duraderas.',
    color: 'border-l-red-500',
    badge: 'bg-red-500',
    value: '$24.99'
  }, {
    id: '05',
    title: '+1500 Planos de Muebles',
    desc: 'Descubrí más de 1500 planos profesionales para construir muebles modernos, resistentes y rentables.',
    color: 'border-l-yellow-400',
    badge: 'bg-yellow-400 text-black',
    value: '$19.99'
  }];
  return <section className="bg-[#0a0e27] py-4 md:py-12 px-4 font-sans border-t border-gray-800" data-id="element-18">
      <div className="max-w-5xl mx-auto" data-id="element-19">
        {/* Header */}
        <div className="text-center mb-4 md:mb-8" data-id="element-20">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4 uppercase" data-id="element-21">
            5 REGALOS EXCLUSIVOS INCLUIDOS
          </h2>
          <div className="inline-block bg-gradient-to-r from-red-600 to-orange-500 text-white font-bold px-6 py-2 rounded-md shadow-[0_0_15px_rgba(239,68,68,0.5)] border border-red-400 text-lg" data-id="element-22">
            🎁 ¡GRATIS POR EL DÍA DE HOY!
          </div>
        </div>

        {/* Bonus Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-5 mb-4 md:mb-8" data-id="element-23">
          {bonuses.map(bonus => <div key={bonus.id} className={`bg-[#111638] rounded-xl p-3 md:p-5 border border-gray-800 border-l-4 ${bonus.color} relative overflow-hidden flex flex-col h-full shadow-2xl`} data-id="element-24">
              <div className="absolute top-0 right-2 text-7xl font-black text-white/5 select-none pointer-events-none leading-none mt-2" data-id="element-25">
                {bonus.id}
              </div>
              <div className="mb-3" data-id="element-26">
                <span className={`${bonus.badge} text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider`} data-id="element-27">
                  Regalo #{bonus.id}
                </span>
              </div>
              <h3 className="text-xl font-bold text-white mb-2 relative z-10" data-id="element-28">
                {bonus.title}
              </h3>
              <p className="text-gray-400 text-sm mb-4 flex-grow relative z-10" data-id="element-29">
                {bonus.desc}
              </p>
              <div className="flex items-center justify-between mt-auto relative z-10 border-t border-gray-800 pt-4" data-id="element-30">
                <span className="text-gray-500 line-through text-base" data-id="element-31">
                  Valor {bonus.value} USD
                </span>
                <span className="bg-[#22c55e] text-white text-sm font-bold px-4 py-1 rounded-md" data-id="element-32">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        {/* Total Value Box */}
        <div className="max-w-sm mx-auto bg-[#111638] border border-gray-700 rounded-lg px-4 py-3 text-center shadow-lg flex items-center justify-center gap-3 flex-wrap" data-id="element-33">
          <p className="text-gray-400 text-sm" data-id="element-34">
            Valor total:{' '}
            <span className="text-red-500 line-through font-bold" data-id="element-35">$119.95</span>
          </p>
          <p className="text-3xl font-black text-[#22c55e]" data-id="element-36">$0</p>
          <p className="text-yellow-400 font-bold text-xs" data-id="element-37">
            ✨ GRATIS con tu compra ✨
          </p>
        </div>
      </div>
    </section>;
}